export { default } from './TablesPage';
